import { render, staticRenderFns } from "./UserPicker.vue?vue&type=template&id=25c207e5&scoped=true"
import script from "./UserPicker.vue?vue&type=script&lang=js"
export * from "./UserPicker.vue?vue&type=script&lang=js"
import style0 from "./UserPicker.vue?vue&type=style&index=0&id=25c207e5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c207e5",
  null
  
)

export default component.exports